import {
  CHANGE_MAIN_DATA,
  REQUEST_USER_DATA,
  BLUR_MAIN_DATA,
  SUBMIT_MAIN_DATA,
  RESET_MAIN_DATA_SUBMIT
} from '../constants';

export const getUserData = payload => ({ type: REQUEST_USER_DATA, payload });
export const changeMainData = payload => ({ type: CHANGE_MAIN_DATA, payload });
export const blurMainData = payload => ({ type: BLUR_MAIN_DATA, payload });
export const submitMainData = payload => ({ type: SUBMIT_MAIN_DATA, payload });
export const resetMainDataSubmit = payload => ({
  type: RESET_MAIN_DATA_SUBMIT,
  payload
});
